import React from 'react';
import { Typography, Button, Avatar, Menu,TextField, Select, MenuItem,CircularProgress, Backdrop, Link } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import API from '../API';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import {Link as RouterLink} from 'react-router-dom';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ErrorIcon from '@mui/icons-material/Error';
import { Document } from 'react-pdf';
import WhatsappIcon from '../whatsapp.png';
import ForumIcon from '@mui/icons-material/Forum';
import OrderIDTableCell from '../components/OrderIDTableCell';
import InputBase from '@mui/material/InputBase';
// const FILES = ["Sürücü Belgesi Ön", "Sürücü Belgesi Arka", "İkametgah Belgesi", "Adli Sicil Kaydı", "Profil Fotoğrafı"];
const VEHICLE_NAMES = ["Motorsiklet", "Sedan", "Doblo", "Minivan", "Panelvan", "Kamyonet","Esnek"];
import SearchIcon from '@mui/icons-material/Search';
import { styled, alpha } from '@mui/material/styles';
const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }));


  const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  }));

  const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)})`,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '20ch',
      },
    },
  }));

var IN_EDIT_MODE = false;

var STATUS = {};
STATUS[0] = {
    t: "Sürücü Bekliyor",
    color: "rgb(80,72,229)"
}
STATUS[1] = {
    t: "Planlanmış",
    color: "rgb(80,72,229)"
}
STATUS[2] = {
    t: "Aktif Sipariş",
    color: "orange"
}
STATUS[3] = {
    t: "Tarih Kesinleş.",
    color: "rgb(80,72,229)"
}
STATUS[10] = {
    t: "Tamamlanmış",
    color: "green"
}
STATUS[11] = {
    t: "Müşteri İptal",
    color: "yellow"
}
STATUS[-1] = STATUS[11];
STATUS[12] = {
    t: "Sürücü İptali",
    color:"crimson"
}
export default class NotificationLog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {loading: true,editing: false, saving: false, approveDriverDialog: false, backdropVisible: false};

        
        var id = props.match.params.id;

        
        if(!id) props.history.goBack();

        this.currentReceiverFilter = "";
    }

    componentDidMount() {
        var id = this.props.match.params.id;
        
        API.fetch("getnotificationlog", {_id: id}).then((e) => {


            this.setState({log: e, loading: false});
        })
        // API.fetch('getapplications').then((e) => {
        //     if(!e.error) this.setState({applications: e});
        // })
    }
    render() {
     

        if(this.state.loading) return <></>
        return <div style={{display:"flex", justifyContent:"center"}}>

            <div style={{maxWidth:900, width:"100%"}}>
            <div style={{marginTop:40, display:"flex", justifyContent:"space-between", alignItems:"center",flexWrap:"wrap",gap: 10}}>
                <div style={{display:"flex"}}>
                    
                    <div style={{marginLeft:0}}>
                        <Typography variant='h4'>Bildirim Detayları</Typography>
                        <div style={{display:"flex", alignItems:"center"}}>
                            <Typography variant='body2'>bildirim_id: </Typography>
                            <div style={{marginLeft:10, backgroundColor:"#E5E7EB", borderRadius:50, paddingLeft:8, paddingRight:8, paddingTop:2, paddingBottom:2}}>
                                <Typography style={{fontWeight:"600"}} variant='body2'>{this.state.log._id}</Typography>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
                

<Badge style={{marginTop:24,padding:0}}>
                <div style={{padding:0}}>
                <Typography style={{marginBottom:20, marginLeft:24, marginTop:24}} variant='h6'>Detaylar</Typography>
                

                <DetailText first label={"Hedef"} value={this.state.log?.sentToWorkers == true?"Sürücü":"Müşteri"} />
                <DetailText  label={"Gönderen"} value={API.getWorkerName(this.state.log.workerId)} />
                <DetailText  label={"Gönderim Tarihi"} value={dateFromObjectId(this.state.log?._id).toLocaleString("tr-TR")} />
                {this.state.log.orderId != undefined && <DetailText editable={false} link={'../order/' + this.state.log.orderId} label={"Sipariş"}  value={"#" + this.state.log.orderId.substring(18).toUpperCase()} />}
                <DetailText  label={"Başlık (TR)"} value={this.state.log?.title?.tr || ""} />
                <DetailText  label={"Metin (TR)"} value={this.state.log?.body?.tr || ""} />

                <DetailText  label={"Başlık (EN)"} value={this.state.log?.title?.en || ""} />
                <DetailText  label={"Metin (EN)"} value={this.state.log?.body?.en || ""} />

                
                <DetailText editable={false} label={"Detay"} value={JSON.stringify(this.state.log?.filter || "")} />
                <DetailText editable={false} label={"Toplam Alıcı"} value={this.state.log.sentIds.length} />
                </div>
            
            </Badge>


            

            <div style={{display:"flex",width:"100%", justifyContent:"flex-end", marginTop:24}}>
            <Search>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="ID ile ara..."
              inputProps={{ 'aria-label': 'search' }}
              onChange={(e) => {
                var wasFilter = this.currentReceiverFilter.length == 24;
                this.currentReceiverFilter = e.currentTarget.value;
                if((this.currentReceiverFilter.length == 24) != wasFilter) {
                    this.forceUpdate();
                }
            }}
            />
          </Search>
            </div>

           

            <Badge style={{marginTop:10,padding:0,width:"100%"}}>
                <div style={{padding:24}}>
                <Typography variant='h6'>Alıcılar</Typography>
                
                </div>
                <div style={{width:"100%", height:30, minWidth: 0}}>

<DataGrid
                autoHeight
                style={{width:"100%"}}
                rows={(this.currentReceiverFilter.length == 24)?this.state.log.sentIds.filter(s => s == this.currentReceiverFilter):this.state.log.sentIds}
                getRowId={(row) => row}
                columns={[{field: "ID",flex: 1,renderCell: (params) => <RouterLink to={(this.state.log.sentToWorkers?'/driver/':'/client/')+params.row}><Link>{params.row}</Link></RouterLink>}]}
                pageSize={50}
                rowsPerPageOptions={[50]}
                sx={{"& .MuiDataGrid-columnHeaders": {
                    backgroundColor:"#F3F4F6",
                    borderRadius:0,
                    minWidth:0
                    
                }}}
            />
                </div>
            
            </Badge>

                
                <div style={{marginTop:24}}>
                    .
                </div>




            
    

        

        </div>
                    
      
        </div>
    }
}



// const DetailText = (props) => {
//     return <div style={{position:"relative",display:"flex", paddingTop:10, paddingBottom:10,alignItems:"center", borderBottom:"solid 1px #E6E8F0", borderTop:(props.first?"solid 1px #E6E8F0":"")}}>
//         {/* <Typography  onCopy={(a) => console.log(a)} >{props.label}</Typography> */}
//         <p  style={{fontWeight:"600", marginLeft:24,content: props.valueData}} onCopy={(a) => {

//         }}>{props.label}</p>

//         {(!IN_EDIT_MODE || props.editable == false) && <Typography style={{position:"absolute", left:"20%"}}>{props.value}</Typography>}
//         {props.customEdit == undefined && IN_EDIT_MODE &&  props.editable != false && <TextField onChange={(e) => props.onChange(e.currentTarget.value)} style={{position:"absolute",right:24, left:"20%", padding:0}} sx={{padding:0, "& .MuiOutlinedInput-input": {paddingTop: "7px", paddingBottom:"7px", paddingLeft:"14px", paddingRight:"14px"}}}  value={props.value} />}
//         {IN_EDIT_MODE && props.customEdit != undefined && props.customEdit()}
//     </div>
// }

const DetailText = (props) => {
    return <div  style={{position:"relative",flexDirection:"column",display:"flex",paddingLeft:24, paddingTop:10, paddingBottom:10, borderBottom:"solid 1px #E6E8F0", borderTop:(props.first?"solid 1px #E6E8F0":"")}}>
        
<div style={{display:"flex",flex:1}}>
        <div style={{maxWidth:180,flex:.6, display:"flex", alignItems:(props.centerLabel)?"center":undefined}}>
        <Typography style={{fontWeight:"600",}}>{props.label}</Typography>
        </div>
        <div className='detailParent' style={{flex:1, alignItems:"center", justifyContent:"center"}}>
        {(!IN_EDIT_MODE || props.editable == false) && props.link == undefined && <p onCopy={(e) => {
            if(props.onCopy)
                props.onCopy(e);
        }} {...props}>{props.value}</p>}
        {(!IN_EDIT_MODE || props.editable == false) && props.link != undefined && <a style={{color:"blue"}} href={props.link} ><Typography {...props}>{props.value}</Typography></a>}
        {props.customEdit == undefined && IN_EDIT_MODE &&  props.editable != false && <TextField onChange={(e) => props.onChange(e.currentTarget.value)}  sx={{padding:0, "& .MuiOutlinedInput-input": {paddingTop: "7px", paddingBottom:"7px", paddingLeft:"14px", paddingRight:"14px"}}}  value={props.value} />}
        {IN_EDIT_MODE && props.customEdit != undefined && props.customEdit()}
        {!IN_EDIT_MODE && props.children && {...props.children}}
        </div>
        {/* 


        {(!IN_EDIT_MODE || props.editable == false) && <Typography {...props} style={{position:"absolute", left:window.innerWidth < 500?"40%":"20%"}}>{props.value}</Typography>}
        {props.customEdit == undefined && IN_EDIT_MODE &&  props.editable != false && <TextField onChange={(e) => props.onChange(e.currentTarget.value)} style={{position:"absolute",right:24, left:"20%", padding:0}} sx={{padding:0, "& .MuiOutlinedInput-input": {paddingTop: "7px", paddingBottom:"7px", paddingLeft:"14px", paddingRight:"14px"}}}  value={props.value} />}
        {IN_EDIT_MODE && props.customEdit != undefined && props.customEdit()} */}

</div>

        {props.altComponent != undefined && props.altComponent}
    </div>
}

var dateFromObjectId = function (objectId) {
    return new Date(parseInt(objectId.substring(0, 8), 16) * 1000);
};

const Badge = (props) => {
    return <div style={{backgroundColor:"white",display:"flex",flexDirection:"column", flex:1,boxShadow:"rgb(100 116 139 / 6%) 0px 1px 1px, rgb(100 116 139 / 10%) 0px 1px 2px", borderRadius:8,padding:24, color:"rgb(18, 24, 40)",...props.style}}>
        {props.children}
    </div>
}